export const cities = [
  {
    title: "Autour de Paris",
    img: "/images/paris.webp",
    city: "paris",
  },
  {
    title: "Autour de Marseille",
    city: "marseille",
    img: "/images/marseille.webp",
  },
  {
    title: "Autour de Lyon",
    city: "lyon",
    img: "/images/lyon.webp",
  },
  {
    title: "Autour de Bordeaux",
    city: "bordeaux",
    img: "/images/bordeaux.webp",
  },
  {
    title: "Autour de Lille",
    city: "lille",
    img: "/images/lille.webp",
  },
  {
    title: "Autour de Montpellier",
    city: "montpellier",
    img: "/images/montpellier.webp",
  },
  {
    title: "Autour de Toulon",
    city: "toulon",
    img: "/images/toulon.webp",
  },
  {
    title: "Autour de Toulouse",
    city: "toulouse",
    img: "/images/toulouse.webp",
  },
];

export const citiesCoords = [
  {
    name: "paris",
    lat: 48.8566,
    lng: 2.3522,
  },
  {
    name: "marseille",
    lat: 43.296482,
    lng: 5.36978,
  },
  {
    name: "lyon",
    lat: 45.764043,
    lng: 4.835659,
  },
  {
    name: "bordeaux",
    lat: 44.837789,
    lng: -0.57918,
  },
  {
    name: "lille",
    lat: 50.633334,
    lng: 3.066667,
  },
  {
    name: "montpellier",
    lat: 43.604652,
    lng: 3.877992,
  },
  {
    name: "toulon",
    lat: 43.175781,
    lng: 5.929547,
  },
  {
    name: "toulouse",
    lat: 43.610769,
    lng: 1.412541,
  },
];
